module.exports = __webpack_public_path__ + "static/media/delantal (1).38e9503f.jpg";